import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";export const styles = (theme: Theme) => {
	return ({
		root: {
		},
		title: {
			fontSize: theme.typography.h3.fontSize,
			fontWeight: theme.typography.h3.fontWeight,
			fontFamily: theme.typography.fontFamily,
			color: theme.palette.custom.textPrimary,
		},
	} satisfies Record<string, CSSObject>)
}
